import Swiper from 'swiper';

const RelatedArticles = () => {
  const relatedArticles = document.querySelectorAll('[related-articles]');

  if (!relatedArticles.length) return;

  relatedArticles.forEach(article => {
    const data = article.dataset;
    const url = data.url.replace('tags', data.tags);

    fetch(url)
      .then(response => response.text())
      .then(res => {
        const temp = document.createElement('div');
        temp.className = 'd-none';
        temp.innerHTML = res;
        const items = temp.querySelectorAll('.swiper-slide');

        items.forEach(item => {
          if (item.dataset.handle === data.handle) {
            item.remove();
          }
        });

        article.innerHTML = temp.innerHTML;

        /* !----------------- SWIPER ------------------! */
        const swiperContainers = document.querySelectorAll('.page-section-articles-slider .swiper-container');

        if (!swiperContainers.length) return;

        swiperContainers.forEach(container => {
          const id = container.closest('.page-section-articles-slider')?.id;

          new Swiper(container, {
            loop: false,
            spaceBetween: 10,
            slidesPerView: 4,
            navigation: {
              nextEl: `#${id} .custom-button-next`,
              prevEl: `#${id} .custom-button-prev`,
            },
            breakpoints: {
              767: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
            },
          });
        });
      })
      .catch(error => console.error('Error fetching related articles:', error));
  });
};

export default RelatedArticles;